import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function rooms(props: WosIconProps) {
  const { className } = props;

  return (
    <svg viewBox="0 0 24 24" className={className}>
      <g>
        <path
          fill="currentColor"
          d="M23.2453 6.1969C23.7094 6.46408 24 6.96096 24 7.50002V22.5C24 23.3297 23.3297 24 22.5 24C21.6703 24 21 23.3297 21 22.5V8.3719L12 3.22783L3 8.3719V22.5C3 23.3297 2.32828 24 1.5 24C0.671719 24 0 23.3297 0 22.5V7.50002C0 6.96096 0.288422 6.46408 0.755625 6.1969L11.2547 0.197644C11.6766 -0.0658406 12.2812 -0.0658406 12.7453 0.197644L23.2453 6.1969ZM10.125 7.87502C10.125 6.83908 10.9641 6.00002 12 6.00002C13.0359 6.00002 13.875 6.83908 13.875 7.87502C13.875 8.91096 13.0359 9.75002 12 9.75002C10.9641 9.75002 10.125 8.91096 10.125 7.87502ZM10.5 24C9.87656 24 9.375 23.4985 9.375 22.875V14.6953L8.11406 17.0344C7.81875 17.5781 7.13906 17.7844 6.59063 17.4891C6.00469 17.1938 5.84062 16.5141 6.13594 15.9656L7.90781 12.6703C8.62969 11.3344 10.0266 10.4578 11.5406 10.4578H12.4594C13.9734 10.4578 15.3703 11.3344 16.0922 12.6703L17.8641 15.9656C18.1594 16.5141 17.9531 17.1938 17.4094 17.4891C16.8609 17.7844 16.1812 17.5781 15.8859 17.0344L14.625 14.6953V22.875C14.625 23.4985 14.1234 24 13.5 24C12.8766 24 12.375 23.4985 12.375 22.875V18.75H11.625V22.875C11.625 23.4985 11.1234 24 10.5 24Z"
        />
      </g>
    </svg>
  );
}

export default rooms;
